import { render, staticRenderFns } from "./menu-config.vue?vue&type=template&id=e47b5bee&scoped=true&"
import script from "./menu-config.vue?vue&type=script&lang=js&"
export * from "./menu-config.vue?vue&type=script&lang=js&"
import style0 from "./menu-config.vue?vue&type=style&index=0&id=e47b5bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b5bee",
  null
  
)

export default component.exports